import {
  element,
  elementType,
  func,
  node,
  oneOfType,
  string,
} from "prop-types";
import styled, { css } from "styled-components/macro";
import { rem, wordWrap } from "polished";

import { BREAKPOINT_WRAPPER } from "../../constants";
import { colors } from "../Styles.variables";

const baseStyles = css`
  padding: ${rem("40px")} ${rem("30px")} ${rem("40px")};

  @media ${BREAKPOINT_WRAPPER} {
    padding: ${rem("40px")} ${rem("60px")} ${rem("110px")};
  }

  h1 {
    font-size: ${rem("40px")};
    line-height: 1.2;
    margin-bottom: ${rem("36px")};
    text-transform: uppercase;
  }

  h2 {
    font-size: ${rem("28px")};
    line-height: 1.2;
    margin-bottom: ${rem("17px")};
    padding-top: ${rem("17px")};
    text-transform: uppercase;
  }

  p {
    line-height: 1.4;
    margin-bottom: ${rem("20px")};

    &.mb-4 {
      margin-bottom: ${rem("30px")};
    }

    &.lead {
      font-size: ${rem("22px")};
    }
  }

  a {
    text-decoration: none;
    ${wordWrap("break-word")}

    &:not(.subtle) {
      color: ${colors.yellow};
    }

    &.subtle {
      color: inherit;
    }

    @media ${BREAKPOINT_WRAPPER} {
      &:not(.subtle) {
        color: ${colors.blue500};
      }
    }

    &:hover {
      text-decoration: underline;
    }

    &:focus {
      outline: ${rem("1px")} dotted;
      outline-offset: ${rem("2px")};
    }
  }
`;

const Article = styled(
  ({ children, tag: Component, targetDevice, ...rest }) => (
    <Component {...rest}>{children}</Component>
  )
)`
  ${baseStyles};
`;

Article.propTypes = {
  children: node,
  tag: oneOfType([element, elementType, func, node, string]),
  targetDevice: string,
};

Article.defaultProps = {
  tag: "article",
};

export default Article;
